const formatter = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 });

function formatPrice(value = 0) {
  return formatter.format(value);
}

export default formatPrice;
